import { z } from 'zod'
import type { Role } from '../constants/roles'

export const NEWS_TITLE_MAX = 200
export const NEWS_BODY_MAX = 5000

/**
 * Кто публикует новости: ADMIN и руководители подразделений — РОП, РОЗ, бухгалтер,
 * логист, руководитель склада (последние трое — с 25.09.2026). Править и удалять
 * каждый может только свои посты, чужие — только ADMIN. Читают ленту все роли.
 */
export const NEWS_WRITER_ROLES: Role[] = [
  'ADMIN',
  'ROP',
  'ROS',
  'ACCOUNTANT',
  'LOGIST',
  'WAREHOUSE_HEAD',
]
export function isNewsWriterRole(role: string | null | undefined): boolean {
  return role ? (NEWS_WRITER_ROLES as string[]).includes(role) : false
}

export const CreateNewsPostSchema = z.object({
  title: z.string().trim().min(1).max(NEWS_TITLE_MAX),
  body: z.string().trim().min(1).max(NEWS_BODY_MAX),
})
export type CreateNewsPostDto = z.infer<typeof CreateNewsPostSchema>

export const UpdateNewsPostSchema = z.object({
  title: z.string().trim().min(1).max(NEWS_TITLE_MAX).optional(),
  body: z.string().trim().min(1).max(NEWS_BODY_MAX).optional(),
})
export type UpdateNewsPostDto = z.infer<typeof UpdateNewsPostSchema>

export interface NewsAuthor {
  id: string
  email: string
  name: string | null
  role: Role
}

export interface NewsPostDto {
  id: string
  title: string
  body: string
  authorId: string | null
  author: NewsAuthor | null
  createdAt: string
  updatedAt: string
}

export interface NewsListResponse {
  items: NewsPostDto[]
  total: number
  page: number
  limit: number
}
